// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3ZhDs){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.jp-regions_24Bvn.disabled_2uhIh:hover{cursor:not-allowed!important}.jp-regions_24Bvn.disabled_2uhIh div,.jp-regions_24Bvn.disabled_2uhIh label{color:#272525!important}.nsAddressForm_33dDy .dualColumn_3zfRT{display:flex;align-content:space-between}.nsAddressForm_33dDy .dualColumn_3zfRT .firstCol_3kB8I{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3ZhDs",
	"jp-regions": "jp-regions_24Bvn",
	"disabled": "disabled_2uhIh",
	"nsAddressForm": "nsAddressForm_33dDy",
	"dualColumn": "dualColumn_3zfRT",
	"firstCol": "firstCol_3kB8I"
};
module.exports = exports;
